import {Component, Input} from '@angular/core';
import {Host, MenuGroup} from "../../../../common";
import {Cart} from "../../../../common";

@Component({
  selector: 'menu-group',
  standalone: false,
  template: `
    <div class="cards mt-3">
      <constraint-info [method]="cart.method" [constraint]="group.constraint"
                       *ngIf="group.constraint"></constraint-info>
      <div [routerLink]="['/grp', group.id]"
           class="card mb-3 is-clickable group-entry" *ngFor="let group of group.children()">
        <div class="overlay-wrap">
          <img class="card-img" [src]="group.image" *ngIf="group.image" alt="{{ group.name }}">
          <div [class.card-img-overlay]="group.image" [class.card-body]="!group.image">
            <div class="card-title mb-0 row h5">
              <div class="col">{{ group.name }}</div>
              <div class="col-auto text-right"><i class="fa fa-arrow-right"></i></div>
            </div>
          </div>
        </div>
        <div class="card-body" *ngIf="group.text">
          <div class="card-text" [innerHTML]="group.text"></div>
        </div>
      </div>
    </div>
    <div class="cards flex-grow-1">
      <menu-item-preview [host]="host" [item]="item" *ngFor="let item of group.items()"></menu-item-preview>
    </div>
`
})
export class MenuGroupComponent {

  @Input() host: Host;
  @Input() cart: Cart;
  @Input() group: MenuGroup;

}
